import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  ToggleButtonGroup,
  ToggleButton,
} from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PropTypes from "prop-types";

const AutoMode = ({ metricType, setMode, onApply }) => {
  const [duration, setDuration] = useState("4m");

  const handleApply = () => {
    onApply(metricType, duration);
    setMode("manual");
  };

  return (
    <Box
      sx={{
        px: 2,
        py: 2,
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Typography
        variant="subtitle2"
        sx={{ fontWeight: 550, fontSize: "0.85rem", mb: 1 }}
      >
        Set Fetching Duration
      </Typography>

      <ToggleButtonGroup
        value={duration}
        exclusive
        onChange={(e, val) => val && setDuration(val)}
        size="small"
        sx={{
          mb: 2,
          "& .MuiToggleButton-root": {
            fontSize: "0.65rem",
            fontWeight: 600,
            px: 1.2,
            py: 0.5,
            minWidth: "64px",
          },
        }}
      >
        <ToggleButton value="2m">2 MINS</ToggleButton>
        <ToggleButton value="4m">4 MINS</ToggleButton>
        <ToggleButton value="6m">6 MINS</ToggleButton>
      </ToggleButtonGroup>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: 1,
          width: "100%",
          mt: 5,
        }}
      >
        <Button
          variant="outlined"
          size="small"
          fullWidth
          sx={{
            fontSize: "0.7rem",
            fontWeight: 600,
            py: 0.6,
            color: "#6B7280",
            borderColor: "#D1D5DB",
            "&:hover": {
              backgroundColor: "#F3F4F6",
              borderColor: "#9CA3AF",
            },
          }}
          onClick={() => setMode("manual")}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          size="small"
          fullWidth
          startIcon={<AccessTimeIcon sx={{ fontSize: 14 }} />}
          sx={{
            fontSize: "0.7rem",
            bgcolor: "#22C55E",
            fontWeight: 600,
            py: 0.6,
          }}
          onClick={handleApply}
        >
          Apply
        </Button>
      </Box>
    </Box>
  );
};

export default AutoMode;

AutoMode.propTypes = {
  metricType: PropTypes.string.isRequired,
  setMode: PropTypes.func.isRequired,
  onApply: PropTypes.func.isRequired,
};
